import script from "./pdca.vue?vue&type=script&lang=ts&setup=true"
export * from "./pdca.vue?vue&type=script&lang=ts&setup=true"

import "./pdca.vue?vue&type=style&index=0&id=73630d3a&lang=scss&scoped=true"

import exportComponent from "E:\\svn\\xmTask(国振资产管理)1\\views\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73630d3a"]])

export default __exports__